import React from 'react';
import CloseIcon from '@mui/icons-material/Close';


export default function ReceptionModal(props) {
    if (!props.open) {
        return null;
    }

    return (
        <React.Fragment>
            <div className="Modal">
                <div className="ModalBg">
                    <div className="ModalContent reception">
                        <header>
                            <h1>Welcome to the Reception Area!</h1>
                        </header>
                        <section>

                            <img src={require('../../assets/images/reception.PNG')} />

                            Sunt voluptate dolore duis quis ea consectetur commodo voluptate ullamco officia ex. Quis adipisicing occaecat deserunt nulla nisi exercitation incididunt magna voluptate exercitation. Dolore eiusmod enim proident voluptate. Deserunt deserunt nisi elit ex in exercitation.

                        </section>
                        <footer>
                            <a href="#" onClick={() => props.onClose()}><CloseIcon style={{ fontSize: 60, color: "black" }} /></a>
                        </footer>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )

}